@if (!lines.length) {
  <p class="no-product" [innerHTML]="'tunnel.purchase-list.empty' | translate"></p>
} @else {
  <ul class="tunnel-cart-list">
    @for (line of lines; track line.ean) {
      <li>
        <ng-casto-tunnel-cart-item [line]="line"></ng-casto-tunnel-cart-item>
      </li>
    }
  </ul>
}
